/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PtwErrorId } from './PtwErrorId';
import {
    PtwErrorIdFromJSON,
    PtwErrorIdFromJSONTyped,
    PtwErrorIdToJSON,
} from './PtwErrorId';
import type { SeverityType } from './SeverityType';
import {
    SeverityTypeFromJSON,
    SeverityTypeFromJSONTyped,
    SeverityTypeToJSON,
} from './SeverityType';
import type { ErrorType } from './ErrorType';
import {
    ErrorTypeFromJSON,
    ErrorTypeFromJSONTyped,
    ErrorTypeToJSON,
} from './ErrorType';
import type { DeviceMeasurementErrorDtoPayload } from './DeviceMeasurementErrorDtoPayload';
import {
    DeviceMeasurementErrorDtoPayloadFromJSON,
    DeviceMeasurementErrorDtoPayloadFromJSONTyped,
    DeviceMeasurementErrorDtoPayloadToJSON,
} from './DeviceMeasurementErrorDtoPayload';
import type { MessageInfoTypeDto } from './MessageInfoTypeDto';
import {
    MessageInfoTypeDtoFromJSON,
    MessageInfoTypeDtoFromJSONTyped,
    MessageInfoTypeDtoToJSON,
} from './MessageInfoTypeDto';

/**
 * 
 * @export
 * @interface DeviceMeasurementErrorDto
 */
export interface DeviceMeasurementErrorDto {
    /**
     * 
     * @type {PtwErrorId}
     * @memberof DeviceMeasurementErrorDto
     */
    id?: PtwErrorId;
    /**
     * 
     * @type {string}
     * @memberof DeviceMeasurementErrorDto
     */
    readonly description?: string | null;
    /**
     * 
     * @type {DeviceMeasurementErrorDtoPayload}
     * @memberof DeviceMeasurementErrorDto
     */
    payload?: DeviceMeasurementErrorDtoPayload | null;
    /**
     * 
     * @type {SeverityType}
     * @memberof DeviceMeasurementErrorDto
     */
    severity?: SeverityType;
    /**
     * 
     * @type {ErrorType}
     * @memberof DeviceMeasurementErrorDto
     */
    errorType?: ErrorType;
    /**
     * 
     * @type {number}
     * @memberof DeviceMeasurementErrorDto
     */
    measurementTimeStamp?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceMeasurementErrorDto
     */
    source?: string | null;
    /**
     * 
     * @type {MessageInfoTypeDto}
     * @memberof DeviceMeasurementErrorDto
     */
    messageInfoType?: MessageInfoTypeDto;
    /**
     * 
     * @type {string}
     * @memberof DeviceMeasurementErrorDto
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceMeasurementErrorDto
     */
    cause?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceMeasurementErrorDto
     */
    remedy?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceMeasurementErrorDto
     */
    readonly code?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceMeasurementErrorDto
     */
    $type?: DeviceMeasurementErrorDtoTypeEnum;
}


/**
 * @export
 */
export const DeviceMeasurementErrorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoDeviceMeasurementErrorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.DeviceMeasurementErrorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DeviceMeasurementErrorDtoTypeEnum = typeof DeviceMeasurementErrorDtoTypeEnum[keyof typeof DeviceMeasurementErrorDtoTypeEnum];



/**
 * Check if a given object implements the DeviceMeasurementErrorDto interface.
 */
export function instanceOfDeviceMeasurementErrorDto(value?: unknown): value is DeviceMeasurementErrorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DeviceMeasurementErrorDtoTypeEnum)[0];
}

export function DeviceMeasurementErrorDtoFromJSON(json: any): DeviceMeasurementErrorDto {
    return DeviceMeasurementErrorDtoFromJSONTyped(json, false);
}

export function DeviceMeasurementErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceMeasurementErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : PtwErrorIdFromJSON(json['id']),
        'description': json['description'] == null ? undefined : json['description'],
        'payload': json['payload'] == null ? undefined : DeviceMeasurementErrorDtoPayloadFromJSON(json['payload']),
        'severity': json['severity'] == null ? undefined : SeverityTypeFromJSON(json['severity']),
        'errorType': json['errorType'] == null ? undefined : ErrorTypeFromJSON(json['errorType']),
        'measurementTimeStamp': json['measurementTimeStamp'] == null ? undefined : json['measurementTimeStamp'],
        'source': json['source'] == null ? undefined : json['source'],
        'messageInfoType': json['messageInfoType'] == null ? undefined : MessageInfoTypeDtoFromJSON(json['messageInfoType']),
        'message': json['message'] == null ? undefined : json['message'],
        'cause': json['cause'] == null ? undefined : json['cause'],
        'remedy': json['remedy'] == null ? undefined : json['remedy'],
        'code': json['code'] == null ? undefined : json['code'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DeviceMeasurementErrorDtoToJSON(value?: Omit<DeviceMeasurementErrorDto, 'description'|'code'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': PtwErrorIdToJSON(value['id']),
        'payload': DeviceMeasurementErrorDtoPayloadToJSON(value['payload']),
        'severity': SeverityTypeToJSON(value['severity']),
        'errorType': ErrorTypeToJSON(value['errorType']),
        'measurementTimeStamp': value['measurementTimeStamp'],
        'source': value['source'],
        'messageInfoType': MessageInfoTypeDtoToJSON(value['messageInfoType']),
        'message': value['message'],
        'cause': value['cause'],
        'remedy': value['remedy'],
        '$type': value['$type'],
    });
}

